export default __webpack_public_path__ + "static/media/about2.8f927a2a.png";